import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { getMasterReviewer } from '../../../redux/actions/masterReviewer'
import ExpertAccountSearchAndTableWidget from '../../../widgets/admin/manage/ExpertAccountSearchAndTableWidget'

export default function ManageExpertAccountsViewOnly() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()

  useEffect(() => {
    handleGetSchema()
    //setSchema(mockSchemas.model)
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getMasterReviewer(5, 1, '', '', '', '', '')
      setSchema(response)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSearch>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema) {
    return (
      <SidebarProposal isSearch>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isSearch>
      <ContentHeader header={'บัญชีผู้ทรงคุณวุฒิ'} isNotCallApi />

      <ExpertAccountSearchAndTableWidget
        haveAccountColumn={true}
        schema={schema}
        isViewOnly={true}
      />
    </SidebarProposal>
  )
}
